import { all, takeLeading } from 'redux-saga/effects';

import * as constants from './constants';
import { startCreateForecastSaga } from './saga.createForecast';
import { startForecastWeekSaga } from './saga.forecastWeek';

export function* watcher() {
  yield all([
    takeLeading(constants.START_CREATE_FORECAST, startCreateForecastSaga),
    takeLeading(constants.START_FORECAST_WEEK, startForecastWeekSaga),
  ]);
}
